import D1 from "../../components/ExcerciseTypes/Design/TypeIn";
import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {
  1: {
    // Exercise num
    unit: "Unit 1",
    id: "SB3-U1-P9-E1",
    audio: "img/FriendsPlus/Page8/Audio/audio-e3-p8.mp3",
    video: "Videos/e3.p8.mp4",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [{ url: "img/FriendsPlus/Page9/E1/1.jpg" }],
      [{ url: "img/FriendsPlus/Page8/E3/4.jpg" }],
      [
        // Column3
        { url: "img/FriendsPlus/Page8/E3/5.jpg" },
        { url: "img/FriendsPlus/Page8/E3/6.jpg", audioUrl: "img/FriendsPlus/Page8/Audio/hinh1-e3-p8.mp3", },
        { url: "img/FriendsPlus/Page8/E3/7.jpg" },
        { url: "img/FriendsPlus/Page8/E3/8.jpg", audioUrl: "img/FriendsPlus/Page8/Audio/hinh2-e3-p8.mp3", },
        { url: "img/FriendsPlus/Page8/E3/9.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page8/E3/10.jpg" }],
      [
        // Column5
        { url: "img/FriendsPlus/Page8/E3/11.jpg" },
        { url: "img/FriendsPlus/Page8/E3/12.jpg", audioUrl: "img/FriendsPlus/Page8/Audio/hinh3-e3-p8.mp3", },
        { url: "img/FriendsPlus/Page8/E3/13.jpg" },
        { url: "img/FriendsPlus/Page8/E3/14.jpg", audioUrl: "img/FriendsPlus/Page8/Audio/hinh4-e3-p8.mp3", },
        { url: "img/FriendsPlus/Page8/E3/15.jpg" },
      ],
    ],
  },
  2: {
    // Exercise num
    unit: "Unit 1",
    id: "SB3-U1-P9-E2",
    audio: "img/FriendsPlus/Page9/Audio/audio-e2-p9.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page9/E2/1.jpg" },
        {
          url: "img/FriendsPlus/Page9/E2/2.jpg",
          audioUrl: "img/FriendsPlus/Page9/Audio/tieude-e2-p9.mp3",
        },
        { url: "img/FriendsPlus/Page9/E2/3.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page9/E2/4.jpg" }],
      [
        // Column3
        { url: "img/FriendsPlus/Page9/E2/5.jpg" },
        {
          url: "img/FriendsPlus/Page9/E2/6.jpg",
          audioUrl: "img/FriendsPlus/Page9/Audio/hinh1-e2-p9.mp3",
        },
        { url: "img/FriendsPlus/Page9/E2/7.jpg" },
        {
          url: "img/FriendsPlus/Page9/E2/8.jpg",
          audioUrl: "img/FriendsPlus/Page9/Audio/hinh2-e2-p9.mp3",
        },
        { url: "img/FriendsPlus/Page9/E2/9.jpg" },
      ],
      [
        // Column4
        { url: "img/FriendsPlus/Page9/E2/10.jpg" },
        {
          url: "img/FriendsPlus/Page9/E2/11.jpg",
          audioUrl: "img/FriendsPlus/Page9/Audio/hinh2-e2-p9.mp3",
        },
        { url: "img/FriendsPlus/Page9/E2/12.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page9/E2/13.jpg" }],
    ],
  },
  3: {
    // Exercise num
    unit: "Unit 1",
    id: "SB3-U1-P9-E3",
    audio: "",
    video: "",
    component: UI,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page9/E3/1.jpg" }]],
  },
  4: {
    // Exercise num
    unit: "Unit 1",
    id: "SB3-U1-P9-E4",
    audio: "",
    video: "",
    component: D1,
    exerciseKey: "img/FriendsPlus/Page9/E4/Key/answerKey.png",
    isAllowSubmit: true,
    checkUppercase: true,
    questionImage: [
      [{ url: "img/FriendsPlus/Page9/E4/1.jpg" }],
      [
        // Column2
        { url: "img/FriendsPlus/Page9/E4/2.jpg" },
        { url: "img/FriendsPlus/Page9/E4/3.jpg", input: true, answer: "There are" },
        { url: "img/FriendsPlus/Page9/E4/4.jpg" },
      ],
      [
        // Column3
        { url: "img/FriendsPlus/Page9/E4/5.jpg" },
        { url: "img/FriendsPlus/Page9/E4/6.jpg", input: true, answer: "There's" },
        { url: "img/FriendsPlus/Page9/E4/7.jpg" },
      ],
      [
        // Column4
        { url: "img/FriendsPlus/Page9/E4/8.jpg" },
        { url: "img/FriendsPlus/Page9/E4/9.jpg", input: true, answer: "There's" },
        { url: "img/FriendsPlus/Page9/E4/10.jpg" },
      ],
      [
        // Column5
        { url: "img/FriendsPlus/Page9/E4/11.jpg" },
        { url: "img/FriendsPlus/Page9/E4/12.jpg", input: true, answer: "There's" },
        { url: "img/FriendsPlus/Page9/E4/13.jpg" },
      ],
    ],
  },
  5: {
    // Exercise num
    unit: "Unit 1",
    id: "SB3-U1-P9-E5",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page9/E5/1.jpg" }]],
  },
};

export default json;
